/* KBM Fabrics - Mobile conversion enhancements */
/* Adds: window.kbmQuickAdd handler + sticky mobile ATC + shipping estimator + relocate care card */
(function(){
  'use strict';

  /* QUICK ADD - activates the existing kbm-quick-add buttons in kbm-product-grid.liquid */
  window.kbmQuickAdd = function(btn){
    if(!btn||btn.disabled)return;
    var variantId=btn.getAttribute('data-variant-id');
    if(!variantId)return;
    var originalContent=btn.innerHTML;
    btn.disabled=true;
    btn.innerHTML='⋯';
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:parseInt(variantId,10),quantity:1}]})
    }).then(function(r){if(!r.ok)throw new Error('add_failed');return r.json();}).then(function(){
      btn.innerHTML='✓';
      btn.classList.add('is-added');
      if(window.KBMCart){
        if(window.KBMCart.refresh)window.KBMCart.refresh();
        if(window.KBMCart.open)setTimeout(window.KBMCart.open,200);
      }
      setTimeout(function(){btn.innerHTML=originalContent;btn.disabled=false;btn.classList.remove('is-added');},1500);
    }).catch(function(){
      btn.innerHTML='!';
      setTimeout(function(){btn.innerHTML=originalContent;btn.disabled=false;},1500);
    });
  };

  /* STICKY MOBILE ADD TO CART */
  function setupStickyATC(){
    if(!document.body.classList.contains('template-product'))return;
    if(/\/products\/kbmfabrics-swatches/i.test(location.pathname))return;
    if(document.querySelector('.kbm-sticky-atc'))return;
    if(window.innerWidth>=750)return;
    var selectors=['form[action*="/cart/add"] button[type="submit"]','form[action*="/cart/add"] button[name="add"]','.product-add-btn','[data-add-to-cart]','#AddToCart'];
    var mainBtn=null;
    for(var i=0;i<selectors.length;i++){mainBtn=document.querySelector(selectors[i]);if(mainBtn)break;}
    if(!mainBtn)return;
    var titleEl=document.querySelector('.product-info h1');
    var priceEl=document.querySelector('.product-price-row .product-price')||document.querySelector('.product-price');
    var title=titleEl?(titleEl.childNodes[0]&&titleEl.childNodes[0].textContent?titleEl.childNodes[0].textContent.trim():titleEl.textContent.trim()):(document.title||'this fabric');
    if(title.length>40)title=title.slice(0,40)+'...';
    var price=priceEl?priceEl.textContent.trim():'';
    var bar=document.createElement('div');
    bar.className='kbm-sticky-atc';
    bar.setAttribute('role','region');
    bar.setAttribute('aria-label','Quick add to cart');
    var safeTitle=title.replace(/[<>]/g,'');
    var safePrice=price.replace(/[<>]/g,'');
    bar.innerHTML='<div class="kbm-sticky-atc__info"><span class="kbm-sticky-atc__title">'+safeTitle+'</span>'+(safePrice?'<span class="kbm-sticky-atc__price">'+safePrice+'</span>':'')+'</div><button type="button" class="kbm-sticky-atc__btn">Add to Cart</button>';
    document.body.appendChild(bar);
    var stickyBtn=bar.querySelector('.kbm-sticky-atc__btn');
    stickyBtn.addEventListener('click',function(){mainBtn.click();});
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting&&e.boundingClientRect.top<0){bar.classList.add('is-visible');}
        else{bar.classList.remove('is-visible');}
      });
    },{threshold:0});
    observer.observe(mainBtn);
  }

  /* RELOCATE CARE CARD - move .kbm-care from top of PDP to below the buy box */
  function relocateCareCard(){
    if(!document.body.classList.contains('template-product'))return;
    var care=document.querySelector('.kbm-care');
    if(!care||care.dataset.kbmMoved==='1')return;
    // Preferred destinations in order: after product-layout, after .kbm-makers-use, before description, end of .kbm-product
    var anchors=[
      document.querySelector('.product-layout'),
      document.querySelector('.kbm-makers-use'),
      document.querySelector('.product-description'),
      document.querySelector('.kbm-spec-sheet')
    ];
    var anchor=null;
    for(var i=0;i<anchors.length;i++){if(anchors[i]){anchor=anchors[i];break;}}
    if(!anchor||!anchor.parentNode)return;
    anchor.parentNode.insertBefore(care,anchor.nextSibling);
    care.dataset.kbmMoved='1';
  }

  /* SHIPPING ESTIMATOR */
  var shippingEstimateCache=null;
  var shippingEstimateLastSubtotal=null;

  function ensureShippingEstimateMarkup(){
    var foot=document.querySelector('.kbm-drawer__foot');
    if(!foot)return null;
    var existing=foot.querySelector('[data-shipping-estimate]');
    if(existing)return existing;
    var row=document.createElement('div');
    row.className='kbm-drawer__ship-est';
    row.setAttribute('data-shipping-estimate','');
    row.innerHTML='<div class="kbm-drawer__ship-est-row"><span class="kbm-drawer__ship-est-label">Est. shipping <small>(USPS, US average)</small></span><strong class="kbm-drawer__ship-est-amount" data-shipping-estimate-amount>Calculating...</strong></div><p class="kbm-drawer__ship-est-note">Final rate calculated at checkout based on your address</p>';
    var subtotalEl=foot.querySelector('.kbm-drawer__subtotal');
    if(subtotalEl&&subtotalEl.nextSibling){foot.insertBefore(row,subtotalEl.nextSibling);}
    else{foot.insertBefore(row,foot.firstChild);}
    return row;
  }

  function fetchShippingEstimate(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      if(!cart||cart.item_count===0)return;
      if(shippingEstimateLastSubtotal===cart.total_price&&shippingEstimateCache!==null){
        displayShippingEstimate(shippingEstimateCache);
        return;
      }
      var row=ensureShippingEstimateMarkup();
      if(!row)return;
      var amountEl=row.querySelector('[data-shipping-estimate-amount]');
      if(amountEl)amountEl.textContent='Calculating...';
      var params=new URLSearchParams();
      params.set('shipping_address[zip]','60601');
      params.set('shipping_address[country]','United States');
      params.set('shipping_address[province]','Illinois');
      fetch('/cart/shipping_rates.json?'+params.toString(),{headers:{'Accept':'application/json'}})
        .then(function(r){if(!r.ok)throw new Error('rate_fail');return r.json();})
        .then(function(data){
          if(!data.shipping_rates||!data.shipping_rates.length){throw new Error('no_rates');}
          var cheapest=data.shipping_rates.reduce(function(a,b){
            return parseFloat(a.price)<=parseFloat(b.price)?a:b;
          });
          var amt=parseFloat(cheapest.price);
          shippingEstimateCache=amt;
          shippingEstimateLastSubtotal=cart.total_price;
          displayShippingEstimate(amt);
        })
        .catch(function(){
          var fallback;
          if(cart.total_price<3000)fallback='$8-12';
          else if(cart.total_price<8000)fallback='$10-18';
          else fallback='$15-25';
          displayShippingEstimate(fallback);
        });
    }).catch(function(){});
  }

  function displayShippingEstimate(value){
    var row=document.querySelector('[data-shipping-estimate]');
    if(!row)return;
    var amountEl=row.querySelector('[data-shipping-estimate-amount]');
    if(!amountEl)return;
    if(typeof value==='number'){
      amountEl.textContent='$'+value.toFixed(2);
    }else{
      amountEl.textContent=value;
    }
    row.style.display='';
  }

  function setupShippingEstimator(){
    var drawer=document.getElementById('kbmDrawer');
    if(!drawer)return;
    var mo=new MutationObserver(function(){
      if(drawer.classList.contains('is-open')||drawer.getAttribute('aria-hidden')==='false'){
        setTimeout(fetchShippingEstimate,250);
      }
    });
    mo.observe(drawer,{attributes:true,attributeFilter:['class','aria-hidden']});
    document.addEventListener('cart:updated',function(){setTimeout(fetchShippingEstimate,300);});
    var origFetch=window.fetch;
    window.fetch=function(){
      var args=arguments;
      var url=(typeof args[0]==='string')?args[0]:(args[0]&&args[0].url);
      var p=origFetch.apply(this,args);
      if(url&&/\/cart\/(add|change|update|clear)/.test(url)){
        p.then(function(){setTimeout(fetchShippingEstimate,400);}).catch(function(){});
      }
      return p;
    };
  }

  function init(){
    setupStickyATC();
    relocateCareCard();
    setupShippingEstimator();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
  else{setTimeout(init,100);}
  document.addEventListener('shopify:section:load',init);
  // Run again after a delay in case care card is rendered late
  setTimeout(relocateCareCard,500);
  setTimeout(relocateCareCard,1500);
})();
